import { render, staticRenderFns } from "./ShoppinglistAddButton.vue?vue&type=template&id=1a0d4e00&scoped=true&"
import script from "./ShoppinglistAddButton.vue?vue&type=script&lang=js&"
export * from "./ShoppinglistAddButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppinglistAddButton.vue?vue&type=style&index=0&id=1a0d4e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d4e00",
  null
  
)

export default component.exports